/*
 * @Author: your name
 * @Date: 2019-10-09 10:50:39
 * @LastEditTime: 2020-05-20 18:26:18
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \smart-dbs-web-pc\src\services\adminAccountApi.js
 */
/* eslint-disable */
import Vue from 'vue'

/**
 *重置密码集成商账号
 * @param {*} params
 */
export const resetIntegratorsPwd = params => {
  return Vue.fetch.post('/apiv1/integrator/resetPwd', params)
}

/**
 *冻结集成商账号
 * @param {*} params
 */
export const freezeIntegratorsAccount = params => {
  return Vue.fetch.post('/apiv1/integrator/freeze', params)
}

/**
 *解冻集成商账号
 * @param {*} params
 */
export const unfreezeIntegratorsAccount = params => {
  return Vue.fetch.post('/apiv1/integrator/unfreeze', params)
}

/**
 *删除集成商账号
 * @param {*} params
 */
export const removeIntegratorsAccount = params => {
  return Vue.fetch.post('/apiv1/integrator/remove', params)
}

/**
 *添加集成商账号
 * @param {*} params
 */
export const addIntegratorsAccount = params => {
  return Vue.fetch.post('/apiv1/integrator/add', params)
}

/**
 *获取集成商列表
 * @param {*} params
 */
export const queryIntegratorsList = params => {
  return Vue.fetch.post('/apiv1/integrator/queryUserList', params)
}

/**
 *获取企业管理员列表
 * @param {*} params
 */
export const queryCompanyUserList = params => {
  return Vue.fetch.post('/apiv1/hr/company/queryCompanyUserList', params)
}

/**
 *添加企业管理员
 * @param {*} params
 */
export const addCompanyUser = params => {
  return Vue.fetch.post('/apiv1/hr/company/addCompanyUser', params)
}

/**
 *更新企业管理员信息
 * @param {*} params
 */
export const updateCompanyUser = params => {
  return Vue.fetch.post('/apiv1/hr/company/updateCompanyUser', params)
}

/**
 *删除企业管理员
 * @param {*} params
 */
export const deleteCompanyUser = params => {
  return Vue.fetch.post('/apiv1/hr/company/deleteCompanyUser', params)
}

/**
 *通过Id获取企业管理员信息
 * @param {*} params
 */
export const queryCompanyUserDetails = params => {
  return Vue.fetch.post('/apiv1/hr/company/queryCompanyUserDetails', params)
}

/**
 *通过Id获取企业管理员信息
 * @param {*} params
 */
export const changeCompanyUserStatus = params => {
  return Vue.fetch.post('/apiv1/hr/company/changeCompanyUserStatus', params)
}

/**
 *重置企业管理员密码
 * @param {*} params
 */
export const resetCompanyUserPassword = params => {
  return Vue.fetch.post('/apiv1/hr/company/resetCompanyUserPassword', params)
}



// WEBPACK FOOTER //
// ./src/services/adminAccountApi.js